<section>
    <div class="card mb-3">
        <div class="grid grid-cols-1 px-3 mb-3">
            <div class="border-b-2 border-slate-300">
                <div class="flex gap-3 items-center pt-[14px]">
                    <div>
                        <button pButton pRipple type="submit" class="px-3 p-button-secondary">
                            <i class="pi pi-chevron-left"></i>
                        </button>
                    </div>
                    <h4 class="m-0 w-80">
                        <p-skeleton width="100%" height="1.5rem" styleClass="mb-2"></p-skeleton>
                    </h4>
                </div>
                <p-divider class="w-full"></p-divider>
            </div>
        </div>

        <div class="pt-2 w-fit pb-2 md:col-span-2 mb-5">
            <div class="profile-pic-div mb-4 d-flex justify-content-center">
                <div class="text-center img-container">
                    <!--                <p-skeleton *ngIf="isUploading" shape="circle" size="11rem" styleClass="mb-2"></p-skeleton>-->
                    <img class="picHolder"
                         src="assets/images/static/img.jpg" alt="User image">
                    <!--        <nz-upload-->
                    <!--            [nzCustomRequest]="customUploadReq"-->
                    <!--            [nzShowUploadList]="false"-->
                    <!--        >-->
                    <p-skeleton width="100%" borderRadius="2rem" height="3rem"></p-skeleton>
                    <!--                          </nz-upload>-->
                </div>
            </div>

        </div>

        <div class="field mb-4">
            <p-skeleton width="17rem" styleClass="mb-2"></p-skeleton>
            <div class="flex gap-1 items-center">
                <p-skeleton width="20rem" height="1.5rem" styleClass="mb-2"></p-skeleton>
            </div>
        </div>
        <div class="p-fluid p-formgrid grid md:grid-cols-1 gap-4 px-3 items-center mt-4">
            <div class="field mb-2">
                <p-skeleton width="17rem" styleClass="mb-2"></p-skeleton>
                <div class="flex gap-1 items-center">
                    <p-skeleton width="20rem" height="1.5rem" styleClass="mb-2"></p-skeleton>
                </div>
            </div>
            <div class="flex flex-col md:flex-row gap-3 md:items-center justify-start mb-2">
                <p-skeleton width="20rem" height="1.5rem" styleClass="mb-2"></p-skeleton>
                <p-skeleton width="8rem" height="2rem" borderRadius="16px" styleClass="mb-2"></p-skeleton>
            </div>
            <div class="flex flex-col md:flex-row gap-3 md:items-center justify-start mb-2">
                <p-skeleton width="20rem" height="1.5rem" styleClass="mb-2"></p-skeleton>
                <p-skeleton width="8rem" height="2rem" borderRadius="16px" styleClass="mb-2"></p-skeleton>
            </div>
        </div>
    </div>
</section>

<section>
    <div class="card">
        <div class="p-fluid p-formgrid grid md:grid-cols-2 gap-4 px-3 pt-3">
            <div class="field">
                <p-skeleton width="17rem" styleClass="mb-2"></p-skeleton>
                <p-skeleton width="20rem" height="1.5rem" styleClass="mb-2"></p-skeleton>
            </div>
            <div class="field">
                <p-skeleton width="17rem" styleClass="mb-2"></p-skeleton>
                <p-skeleton width="20rem" height="1.5rem" styleClass="mb-2"></p-skeleton>
            </div>
            <div class="p-fluid p-formgrid grid md:grid-cols-4 gap-4 px-3 pt-3">
                <div class="field">
                    <p-skeleton width="17rem" styleClass="mb-2"></p-skeleton>
                    <p-skeleton width="20rem" height="1.5rem" styleClass="mb-2"></p-skeleton>
                </div>
            </div>
            <div class="p-fluid p-formgrid grid md:grid-cols-4 gap-4 px-3 pt-3">
                <div class="field">
                    <p-skeleton width="17rem" styleClass="mb-2"></p-skeleton>
                    <p-skeleton width="20rem" height="1.5rem" styleClass="mb-2"></p-skeleton>
                </div>
            </div>
        </div>
        <div class="p-fluid p-formgrid grid md:grid-cols-2 gap-4 px-3 pt-3">
            <div class="field p-formgrid grid md:grid-cols-2 gap-4 px-3">
                <div class="field mt-2">
                    <p-skeleton width="17rem" styleClass="mb-2"></p-skeleton>
                    <p-skeleton width="20rem" height="1.5rem" styleClass="mb-2"></p-skeleton>
                </div>
                <div class="field mt-2">
                    <p-skeleton width="17rem" styleClass="mb-2"></p-skeleton>
                    <p-skeleton width="20rem" height="1.5rem" styleClass="mb-2"></p-skeleton>
                </div>
            </div>
        </div>

        <p-divider class="w-full"></p-divider>
        <div class="p-fluid p-formgrid grid md:grid-cols-2 gap-4 px-3 pt-3">
            <div class="field">
                <p-skeleton width="17rem" styleClass="mb-2"></p-skeleton>
                <p-skeleton width="20rem" height="1.5rem" styleClass="mb-2"></p-skeleton>
            </div>
            <div class="field">
                <p-skeleton width="17rem" styleClass="mb-2"></p-skeleton>
                <p-skeleton width="20rem" height="1.5rem" styleClass="mb-2"></p-skeleton>
            </div>
            <div class="field">
                <p-skeleton width="17rem" styleClass="mb-2"></p-skeleton>
                <p-skeleton width="20rem" height="1.5rem" styleClass="mb-2"></p-skeleton>
            </div>
            <div class="field">
                <p-skeleton width="17rem" styleClass="mb-2"></p-skeleton>
                <p-skeleton width="20rem" height="1.5rem" styleClass="mb-2"></p-skeleton>
            </div>
            <div class="field">
                <p-skeleton width="17rem" styleClass="mb-2"></p-skeleton>
                <p-skeleton width="20rem" height="1.5rem" styleClass="mb-2"></p-skeleton>
            </div>
            <div class="field">
                <p-skeleton width="17rem" styleClass="mb-2"></p-skeleton>
                <p-skeleton width="20rem" height="1.5rem" styleClass="mb-2"></p-skeleton>
            </div>
        </div>

        <div class="">
            <form action="">
                <div class="p-fluid p-formgrid grid md:grid-cols-2 px-3 gap-3 mt-4">
                    <div class="field">
                        <p-skeleton width="17rem" styleClass="mb-2"></p-skeleton>
                        <p-skeleton width="20rem" height="1.5rem" styleClass="mb-2"></p-skeleton>
                    </div>
                    <div class="field">
                        <p-skeleton width="17rem" styleClass="mb-2"></p-skeleton>
                        <p-skeleton width="20rem" height="1.5rem" styleClass="mb-2"></p-skeleton>
                    </div>
                    <div class="field">
                        <p-skeleton width="17rem" styleClass="mb-2"></p-skeleton>
                        <p-skeleton width="20rem" height="1.5rem" styleClass="mb-2"></p-skeleton>
                    </div>
                    <div class="field">
                        <p-skeleton width="17rem" styleClass="mb-2"></p-skeleton>
                        <p-skeleton width="20rem" height="1.5rem" styleClass="mb-2"></p-skeleton>
                    </div>
                    <div class="field">
                        <p-skeleton width="17rem" styleClass="mb-2"></p-skeleton>
                        <p-skeleton width="20rem" height="1.5rem" styleClass="mb-2"></p-skeleton>
                    </div>
                </div>
            </form>
        </div>
        <p-divider class="w-full"></p-divider>

        <form>
            <div class="p-fluid p-formgrid grid md:grid-cols-2 gap-4 px-3 pt-3">
                <div class="field md:col-span-2 mt-2">
                    <p-skeleton width="17rem" styleClass="mb-2"></p-skeleton>
                    <p-skeleton width="20rem" height="1.5rem" styleClass="mb-2"></p-skeleton>
                </div>
            </div>
        </form>

        <div class="p-fluid p-formgrid grid md:grid-cols-2 gap-4 px-3 pt-3">
            <div class="field">
                <p-skeleton width="17rem" styleClass="mb-2"></p-skeleton>
                <p-skeleton width="20rem" height="1.5rem" styleClass="mb-2"></p-skeleton>
            </div>

            <div class="field">
                <p-skeleton width="17rem" styleClass="mb-2"></p-skeleton>
                <p-skeleton width="20rem" height="1.5rem" styleClass="mb-2"></p-skeleton>
            </div>

        </div>
    </div>
</section>

<section>
    <div class="card flex items-center justify-end mt-3 px-3">
        <p-skeleton width="8rem" height="2.3rem" borderRadius="16px" styleClass="mb-2"></p-skeleton>
    </div>
</section>

